import { HStack } from '@chakra-ui/react';
import * as React from 'react';

import {
  AttachmentButton,
  AttachmentPreview,
  Body,
  Container,
  ImageButton,
  ImagePreview,
  Title,
} from '@/components/post-form';

import { PostSettings } from '../PostSettings';

export const SimplePostForm: React.FC<{
  organizationId?: string;
  initialGroupId?: string;
  originalImages?: { imageId: string; imageProxy: string }[];
  isEditing?: boolean;
  isPublished?: boolean;
}> = ({
  organizationId,
  initialGroupId,
  originalImages,
  isEditing,
  isPublished,
}) => {
  const validationMessage = 'A post requires a title or body.';

  return (
    <Container>
      <Title
        formLabel="Message title"
        placeholder="What is your message about?"
        validationMessage={validationMessage}
      />
      <Body
        formLabel="Content"
        placeholder="Write the content for your message"
        validationMessage={validationMessage}
      />
      <HStack>
        <ImageButton imageLimit={20} />
        <AttachmentButton attachmentLimit={10} />
      </HStack>
      <ImagePreview originalImages={originalImages} />
      <AttachmentPreview />

      <PostSettings
        isEditing={!!isEditing}
        isPublished={!!isPublished}
        initialGroupId={initialGroupId}
        organizationId={organizationId}
      />
    </Container>
  );
};
